<span class="load-event-value" *ngIf="value">
    {{ value | fullDate }}
</span>
